import { QuestionAnswerEditorViewModelBase } from '@/features/jobs/questions/QuestionAnswerEditorViewModelBase'
import type { UnknownQuestion } from '@/features/jobs/questions/questions'
import { QuestionValidationResult } from '@/features/jobs/questions/question-validation-result'

export class UnknownQuestionAnswerEditorViewModel extends QuestionAnswerEditorViewModelBase<UnknownQuestion> {
  /** @inheritDoc */
  readonly isAnswered = false
  /** @inheritDoc */
  readonly textAnswer = 'Unknown'
  /** @inheritDoc */
  readonly type = 'Unknown'
  /** @inheritDoc */
  readonly answer = null

  constructor() {
    super()
  }

  /** @inheritDoc */
  validate(): QuestionValidationResult {
    return QuestionValidationResult.failed(['Unsupported question type'])
  }

  /** @inheritDoc */
  set(_question: UnknownQuestion): void {
    // No-op
  }
}
